// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".panel-wrapper[data-v-58f1c1ee]{background:#fff;padding:1.042vw;border:1px solid #e1e1e1}.panel-content[data-v-58f1c1ee]{height:15.104vw;display:flex}.panel-content .left[data-v-58f1c1ee]{width:8.333vw;height:100%;display:flex;flex-direction:column;justify-content:center;align-items:center;padding-top:1.563vw}.panel-content .right[data-v-58f1c1ee]{display:flex;flex-direction:column;flex-grow:1}", ""]);
// Exports
module.exports = exports;
